var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Notes","label_align_top":true}},[_c('div',{staticClass:"w-full"},[_c('input-textarea',{attrs:{"name":"roads_notes"},model:{value:(_vm.commercial.roads_notes),callback:function ($$v) {_vm.$set(_vm.commercial, "roads_notes", $$v)},expression:"commercial.roads_notes"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }